export enum AccountTypeEnum {
  SYSTEM = 'System'
}
